"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../../pragma");

var _react = _interopRequireWildcard(require("react"));

var _VideoInfo = _interopRequireWildcard(require("./VideoInfo/VideoInfo"));

var styles = _interopRequireWildcard(require("./Video.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Video = ({
  story,
  isPaused,
  isLoaded,
  isMuted,
  onChangeVideoDuration,
  onMediaLoaded,
  onPause,
  onPlay,
  onMute,
  onUnmute,
  onError
}) => {
  const [videoDuration, setVideoDuration] = (0, _react.useState)(0);

  const videoElement = _react.default.useRef(null);

  (0, _react.useEffect)(() => {
    if (videoElement.current && isLoaded) {
      if (isPaused) {
        videoElement.current.pause();
      } else {
        videoElement.current.play().catch(onError);
      }
    }
  }, [isPaused, isLoaded, onError]);

  const videoLoaded = () => {
    if (videoElement.current) {
      const newVideoDuration = videoElement.current.duration * 1000;
      setVideoDuration(newVideoDuration);
      onChangeVideoDuration(newVideoDuration);
      onMediaLoaded();
    }
  };

  return (0, _pragma.createFelaElement)(_react.default.Fragment, null, (0, _pragma.createFelaElement)("video", {
    ref: videoElement,
    src: story.url,
    controls: false,
    muted: isMuted,
    css: styles.video,
    playsInline: true,
    onLoadedData: videoLoaded,
    onError: onError,
    onWaiting: onPause,
    onPlaying: onPlay,
    onPause: onPause
  }), (0, _pragma.createFelaElement)(_VideoInfo.default, {
    css: styles.videoInfo,
    name: story.videoTitle || 'No name',
    duration: videoDuration,
    isMuted: isMuted,
    onMute: onMute,
    onUnmute: onUnmute
  }));
};

var _default = Video;
exports.default = _default;
//# sourceMappingURL=Video.js.map